import { TableColumnsType } from "antd";
import { useCallback, useMemo } from "react";
import { Theme } from "../../../../types/thematiques";
import DropdownOptionsThemes from "../components/DropdownOptionsThemes/DropdownOptionsThemes";

type Options = {
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
};

export default function useTableThemes({ onModify, onDelete }: Options) {
  const columns = useMemo(() => {
    const _columns: TableColumnsType<Theme> = [
      {
        title: "CODE",
        dataIndex: "code",
        key: "code",
        align: "left",
        width: 120,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "DESCRIPTION",
        dataIndex: "description",
        key: "description",
        align: "left",
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "",
        dataIndex: "",
        align: "center",
        key: "actions",
        width: 10,
        render: (_, item) => (
          <DropdownOptionsThemes
            itemId={item.id}
            onModify={onModify}
            onDelete={onDelete}
          />
        ),
      },
    ];
    return _columns;
  }, [onModify, onDelete]);

  const onRowClick = useCallback(
    (record: Theme) => ({ onClick: () => onModify(record.id) }),
    [onModify],
  );

  return { columns, onRowClick };
}
